import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Botao = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }
`;
